import { StepShell, SectionGroup } from '../components/layout';
import { TextArea } from '../components/inputs';
import { ChoiceCards, TagSelect } from '../components/selection';

export default function AiJourneyStep({ data, update, notes = {}, config }) {
  const tools = data.tools || [];
  const toolOptions = config.aiTools.map((name) => ({ key: name, label: name }));

  return (
    <StepShell
      eyebrow="Step 6 of 18"
      title="Your AI journey"
      lede="Wherever you are with this is genuinely fine. Some of the best people we work with had never opened an AI tool before they started."
      why="AI is part of how most of our teams work now. Knowing your starting point means we can pitch your first few weeks correctly instead of guessing."
    >
      <ChoiceCards
        label="Where would you put yourself right now?"
        options={config.aiFamiliarity}
        value={data.familiarity}
        note={notes.familiarity}
        onChange={(v) => update({ familiarity: v })}
      />

      {data.familiarity && data.familiarity !== 'new' && (
        <SectionGroup label="Tell us a bit more">
          <TagSelect
            label="Anything you have used"
            optional
            options={toolOptions}
            values={tools}
            onChange={(v) => update({ tools: v })}
          />

          <TextArea
            id="ai_story"
            label="What have you used it for?"
            optional
            rows={3}
            maxLength={600}
            placeholder="Studying, writing, coding, making things — whatever it has been."
            value={data.story}
            note={notes.story}
            onChange={(v) => update({ story: v })}
          />
        </SectionGroup>
      )}

      {data.familiarity === 'new' && (
        <p className="ob-encourage">
          <span>
            That is a perfectly good place to start. We will teach you this
            properly — you are not expected to arrive knowing it.
          </span>
        </p>
      )}
    </StepShell>
  );
}
